export const SERVICE_FEE = {
    percent: 3,
    fixedPerTicket: 49
}

export const MAX_TICKETS_PER_ORDER = 10

export const ORDER_HOLD_MINUTES = 40

export const CHECKOUT_SESSION_MINUTES = 31

export const SESSION_COOKIE = 'turnout_session'

export const SESSION_DAYS = 30

export const EVENTS_PER_PAGE = 12

export const CURRENCIES = [
    { code: 'usd', label: 'US dollar (USD)' },
    { code: 'eur', label: 'Euro (EUR)' },
    { code: 'gbp', label: 'British pound (GBP)' },
    { code: 'cad', label: 'Canadian dollar (CAD)' },
    { code: 'aud', label: 'Australian dollar (AUD)' }
]

export const TIMEZONES = [
    { value: 'Pacific/Honolulu', label: 'Honolulu' },
    { value: 'America/Anchorage', label: 'Anchorage' },
    { value: 'America/Los_Angeles', label: 'Los Angeles, San Francisco, Seattle' },
    { value: 'America/Phoenix', label: 'Phoenix' },
    { value: 'America/Denver', label: 'Denver' },
    { value: 'America/Chicago', label: 'Chicago, Austin, Dallas' },
    { value: 'America/New_York', label: 'New York, Toronto, Miami' },
    { value: 'America/Halifax', label: 'Halifax' },
    { value: 'America/Sao_Paulo', label: 'Sao Paulo' },
    { value: 'America/Mexico_City', label: 'Mexico City' },
    { value: 'Europe/London', label: 'London, Dublin, Lisbon' },
    { value: 'Europe/Paris', label: 'Paris, Madrid, Amsterdam' },
    { value: 'Europe/Berlin', label: 'Berlin, Rome, Stockholm' },
    { value: 'Europe/Athens', label: 'Athens, Helsinki' },
    { value: 'Europe/Istanbul', label: 'Istanbul' },
    { value: 'Africa/Lagos', label: 'Lagos' },
    { value: 'Africa/Johannesburg', label: 'Johannesburg' },
    { value: 'Asia/Dubai', label: 'Dubai' },
    { value: 'Asia/Kolkata', label: 'Mumbai, Delhi, Bengaluru' },
    { value: 'Asia/Singapore', label: 'Singapore' },
    { value: 'Asia/Tokyo', label: 'Tokyo' },
    { value: 'Australia/Sydney', label: 'Sydney, Melbourne' },
    { value: 'Pacific/Auckland', label: 'Auckland' },
    { value: 'UTC', label: 'UTC' }
]

export const ORDER_STATUS_LABELS: Record<string, string> = {
    pending: 'Awaiting payment',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    refunded: 'Refunded'
}

export const EVENT_STATUS_LABELS: Record<string, string> = {
    draft: 'Draft',
    published: 'On sale',
    cancelled: 'Cancelled'
}
